<!-- 3rd Claims-->
<div class="tab-pane" id="tabs-3" role="tabpanel">
  <div *ngIf="!IsClaimCancel">
    <div class="row">
      <div class="col-md-12">
        <div class="col-md-12 text-right">
          <!-- <a (click)="IsClaimCancel = true;" class="btn btn-primary save_btn font-600">Create New Claim</a> -->
          <button pButton type="button" class="btn btn-primary save_btn font-600" label="Create New Claim"
            (click)="IsClaimCancel = true;"></button>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 mt-3 ">
        <!-- <table class="claims_table table-responsive" width="100%">
          <tr>
            <th>Date of Loss</th>
            <th class="text-center">Policy Number</th>
            <th>Jobsite Address</th>
            <th>Policy Period</th>
            <th>Loss Type</th>
            <th class="text-center">Status</th>
          </tr>

          <tr>
            <td>08/14/2020</td>
            <td class="text-center">9010631</td>
            <td>555, Main Street <br>
              Des Plaines, II 60016
            </td>
            <td>08/01/2020 - 08/01/2021</td>
            <td>Fire</td>
            <td class="text-center"><a href="#" class="tbtn_new">NEW</a></td>
          </tr>

          <tr>
            <td>08/14/2020</td>
            <td class="text-center">9010631</td>
            <td>555, Main Street <br>
              Des Plaines, II 60016
            </td>
            <td>08/01/2020 - 08/01/2021</td>
            <td>Water Damage</td>
            <td class="text-center"><a href="#" class="tbtn_open">OPEN</a></td>
          </tr>

          <tr>
            <td>08/14/2020</td>
            <td class="text-center">9010631</td>
            <td>555, Main Street <br>
              Des Plaines, II 60016
            </td>
            <td>08/01/2020 - 08/01/2021</td>
            <td>Theft/Vandalism</td>
            <td class="text-center"><a href="#" class="tbtn_closed">CLOSED</a></td>
          </tr>
        </table> -->
        <p-table class="table client-table table-responsive" class="gen-paginator-override" [value]="dao?.claimDetails"
          [rows]="10" [paginator]="true" pageLinks="8">
          <ng-template pTemplate="header">
            <tr>
              <th>Date of Loss</th>
              <th class="text-center">Policy Number</th>
              <th>Jobsite Address</th>
              <th>Policy Period</th>
              <th>Loss Type</th>
              <th class="text-center">Status</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-claims let-i="rowIndex">
            <tr>
              <td>{{claims?.dateOfLoss | date:"MM/dd/yyyy"}}</td>
              <td class="text-center">{{claims?.policyNumber}}</td>
              <td>{{claims?.jobSiteAddress}}</td>
              <td>{{claims?.policyPeriod}}</td>
              <td title="{{claims?.lossType}}">
                <div class="wrpText">{{claims?.lossType}}</div>
              </td>
              <td class="text-center">
                <span style="display: flex; justify-content: center; text-transform: uppercase;">
                  <span [ngClass]="getColorCode(claims?.status)">{{claims?.status}}</span>
                </span>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
  <div *ngIf="IsClaimCancel">
    <div class="row m-0">
      <div class="col-lg-12 col-md-12 col-12 d-flex pb-2 mt-3 p-0 border_bottom_heading">
        <div class="col-lg-6 col-md-6 col-5 pl-0 pr-0 pl-lg-3 pr-lg-3">
          <span class="heading_cls_claim">New Claim</span>
        </div>
        <div class="col-lg-6 col-md-6 col-7 text-right">
          <a (click)="IsClaimCancel = false;" class="btn btn-primary mt-0  mr-0 cancel_btn font-600">Cancel New
            Claim</a>
        </div>
      </div>

    </div>

    <div class="row mt-3 mb-2">
      <div class="col-lg-2 col-md-4 text-right">
        <label class="claim_label">Date of Loss:</label>
      </div>
      <div class="col-lg-2 col-md-8 pl-lg-0">
        <!-- <input type="date" name="bday" max="3000-12-31" min="1000-01-01" class="form-control"> -->
        <p-calendar dateFormat="mm/dd/yy" [showIcon]="true" inputId="icon"></p-calendar>
      </div>
    </div>

    <div class="row mt-3 mb-2">
      <div class="col-lg-2 col-md-4 text-right">
        <label class="claim_label">Policy Number:</label>
      </div>
      <div class="col-lg-2 col-md-8 pl-lg-0">
        <!-- <select class="form-control classic">
          <option></option>
        </select> -->
        <p-dropdown width="100%"></p-dropdown>
      </div>
    </div>

    <div class="row mt-3 mb-2">
      <div class="col-lg-2 col-md-4 text-right">
        <label class="claim_label">Policy Period:</label>
      </div>
      <div class="col-lg-2 col-md-8 pl-lg-0">
        <label class="claim_data_label">08/01/2020 - 08/01/2021</label>
      </div>
    </div>

    <div class="row mt-4 ml-0 mr-0">
      <div class="col-md-12">
        <div class="claim_new_heading">Insured</div>
      </div>
    </div>

    <div class="row mt-0 mb-0">
      <div class="col-lg-2 col-md-4 text-right">
        <label class="claim_label">Name:</label>
      </div>
      <div class="col-lg-2 col-md-8 pl-lg-0">
        <label class="claim_data_label">Mike Johnson</label>
      </div>
    </div>

    <div class="row mt-0 mb-0">
      <div class="col-lg-2 col-md-4 text-right">
        <label class="claim_label">Mailing Address:</label>
      </div>
      <div class="col-lg-2 col-md-8 pl-lg-0">
        <label class="claim_data_label">555 West Oak Street <br>Niles, IL 60714</label>
      </div>
    </div>

    <div class="row mt-0 mb-0">
      <div class="col-lg-2 col-md-4 text-right">
        <label class="claim_label">Jobsite Address:</label>
      </div>
      <div class="col-lg-2 col-md-8 pl-lg-0">
        <label class="claim_data_label">2140 Elmira<br>Des Plaines, IL 60016</label>
      </div>
    </div>

    <div class="row mt-4 ml-0 mr-0">
      <div class="col-md-12">
        <div class="claim_new_heading">Loss</div>
      </div>
    </div>

    <div class="row mt-0 mb-0">
      <div class="col-lg-2 col-md-4 text-right">
        <label class="claim_label">Lost Type:</label>
      </div>
      <div class="col-lg-2 col-md-8 pl-lg-0">
        <!-- <select class="form-control classic">
          <option></option>
        </select> -->
        <p-dropdown></p-dropdown>
      </div>
    </div>

    <div class="row mt-0 mb-0">
      <div class="col-lg-2 col-md-4 text-right">
        <label class="claim_label">Location:</label>
      </div>
      <div class="col-lg-3 col-md-8 pl-lg-0">
        <!-- <p-radioButton name="radio"></p-radioButton>
        <label class="radio_btn_cls"><b>Jobsite Address </b><br /> 2140 Elmira <br />Des Plaines, IL 60016 -->
        <!-- <input type="radio" checked="checked" name="radio">
          <span class="checkmark"></span> -->

        <!-- </label> -->
        <div class="p-field-radiobutton">
          <p-radioButton name="Address" value="Address1" inputId="Address1"></p-radioButton>
          <label class="p_radiobtn_labelcls" for="Address1"><b>Jobsite Address </b><br /> 2140 Elmira <br />Des Plaines,
            IL 60016</label>
        </div>
      </div>
    </div>

    <div class="row mt-2 mb-0">
      <div class="col-lg-2 col-md-4 text-right">
        <label class="claim_label">&nbsp;</label>
      </div>
      <div class="col-lg-3 col-md-8 pl-lg-0">
        <div class="p-field-radiobutton">
          <p-radioButton name="NewAddress1" value="NewAddress1" inputId="NewAddress1"></p-radioButton>
          <label class="p_radiobtn_labelcls" for="NewAddress1"><b>New Address </b></label>
        </div>
        <!-- <label class="radio_btn_cls"><b>New Address </b> -->
        <!-- <input type="radio" name="radio">
          <span class="checkmark"></span> -->
        <!-- <p-radioButton name="radio"></p-radioButton> -->
        <!-- </label> -->
      </div>
    </div>

    <div class="row mt-3 mb-0">
      <div class="col-lg-2 col-md-4 text-right">
        <label class="claim_label">Description:</label>
      </div>
      <div class="col-lg-8 col-md-8 pl-lg-0">
        <textarea class="form-control" rows="5">  </textarea>
      </div>
    </div>

    <div class="row mt-4 ml-0 mr-0">
      <div class="col-md-12">
        <div class="claim_new_heading">Police/Fire Report</div>
      </div>
    </div>

    <div class="row mt-0 mb-0">
      <div class="col-lg-2 col-md-4 text-right">
        <label class="claim_label">Police Report Filed?</label>
      </div>
      <div class="col-lg-2 col-md-8 pl-lg-0">
        <div class="p-field-radiobutton">
          <p-radioButton name="Yes1" value="Yes1" inputId="Yes1"></p-radioButton>
          <label class="p_radiobtn_labelcls" for="Yes1"><b>Yes </b></label>
        </div>
        <div class="p-field-radiobutton">
          <p-radioButton name="No1" value="No1" inputId="No1"></p-radioButton>
          <label class="p_radiobtn_labelcls" for="No1"><b>No </b></label>
        </div>
        <!-- <label class="radio_btn_cls"><b>Yes</b> -->
        <!-- <input type="radio" checked="checked" name="radio"> -->
        <!-- <p-radioButton name="radio"></p-radioButton> -->
        <!-- <span class="checkmark"></span> -->
        <!-- </label> -->
        <!-- <label class="radio_btn_cls"><b>No</b> -->
        <!-- <input type="radio" name="radio"> -->
        <!-- <p-radioButton name="radio"></p-radioButton> -->
        <!-- <span class="checkmark"></span> -->
        <!-- </label> -->
      </div>
    </div>

    <div class="row mt-4 mb-0">
      <div class="col-lg-2 col-md-4 text-right">
        <label class="claim_label mt-0">Jurisdiction:
          <br /><i>(if known)</i>
        </label>
      </div>
      <div class="col-lg-3 col-md-8 pl-lg-0">
        <input type="text" class="form-control">
      </div>
    </div>

    <div class="row mt-0 mb-3">
      <div class="col-lg-2 col-md-4 text-right">
        <label class="claim_label">Report Number:</label>
      </div>
      <div class="col-lg-3  col-md-8 pl-lg-0">
        <input type="text" class="form-control">
      </div>
    </div>

    <div class="row mt-0 mb-0">
      <div class="col-lg-2 col-md-4 text-right">
        <label class="claim_label mt-0">Responding Officer Name:</label>
      </div>
      <div class="col-lg-3 col-md-8 pl-lg-0">
        <input type="text" class="form-control">
      </div>
    </div>

    <div class="row mt-4 ml-0 mr-0">
      <div class="col-md-12">
        <div class="claim_new_heading">Witness Information</div>
      </div>
    </div>

    <div class="row mt-0 mb-0">
      <div class="col-lg-2 col-md-4 text-right">
        <label class="claim_label">Is there any witnesses?</label>
      </div>
      <div class="col-lg-2 col-md-8 pl-lg-0">
        <div class="p-field-radiobutton">
          <p-radioButton name="Yes2" value="Yes2" inputId="Yes2"></p-radioButton>
          <label class="p_radiobtn_labelcls" for="Yes2"><b>Yes </b></label>
        </div>
        <div class="p-field-radiobutton">
          <p-radioButton name="No2" value="No2" inputId="No2"></p-radioButton>
          <label class="p_radiobtn_labelcls" for="No2"><b>No </b></label>
        </div>
        <!-- <label class="radio_btn_cls"><b>Yes</b> -->
        <!-- <input type="radio" checked="checked" name="radio"> -->
        <!-- <p-radioButton name="radio"></p-radioButton> -->
        <!-- <span class="checkmark"></span> -->
        <!-- </label> -->
        <!-- <label class="radio_btn_cls"><b>No</b> -->
        <!-- <input type="radio" name="radio">
          <span class="checkmark"></span> -->
        <!-- <p-radioButton name="radio"></p-radioButton>
        </label> -->
      </div>
    </div>

    <div class="row mt-3 mb-3">
      <div class="col-lg-2 col-md-4 text-right">
        <label class="claim_label">First Name:</label>
      </div>
      <div class="col-lg-3 col-md-8 pl-lg-0">
        <input type="text" class="form-control">
      </div>
      <div class="col-lg-2 mt-2 mt-lg-0 col-md-4 text-right">
        <label class="claim_label">Last Name:</label>
      </div>
      <div class="col-lg-3  mt-2 mt-lg-0  col-md-8 pl-lg-0">
        <input type="text" class="form-control">
      </div>
    </div>

    <div class="row mt-3 mb-3">
      <div class="col-lg-2 col-md-4 text-right">
        <label class="claim_label">Address:</label>
      </div>
      <div class="col-lg-4 col-md-8 pl-lg-0">
        <input type="text" class="form-control">
      </div>
    </div>

    <div class="row mt-3 mb-3">
      <div class="col-lg-2 col-md-4 text-right">
        <label class="claim_label">City, State, Zip:</label>
      </div>
      <div class="col-lg-4 col-md-8 pl-lg-0">
        <div class="row">
          <div class="col-lg-5 col-md-5">
            <input type="text" class="form-control">
          </div>
          <div class="col-lg-3 mt-3 mb-3 mt-lg-0 mb-lg-0 col-md-3 p-lg-0">
            <!-- <select class="form-control classic">
              <option></option>
            </select> -->
            <p-dropdown></p-dropdown>
          </div>
          <div class="col-lg-4 col-md-4">
            <input type="text" class="form-control">
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-3 mb-3">
      <div class="col-lg-2 col-md-4 text-right">
        <label class="claim_label">Phone Number:</label>
      </div>
      <div class="col-lg-3 col-md-8 pl-lg-0">
        <input type="text" class="form-control">
      </div>
    </div>

    <div class="row mt-3 mb-0">
      <div class="col-lg-2 col-md-4 text-right">
        <label class="claim_label">Witness Statement:</label>
      </div>
      <div class="col-lg-8 col-md-8 pl-lg-0">
        <textarea class="form-control" rows="5">  </textarea>
      </div>
    </div>

    <div class="row mt-4 ml-0 mr-0">
      <div class="col-md-12">
        <div class="claim_new_heading">Reported By</div>
      </div>
    </div>

    <div class="row mt-0 mb-3">
      <div class="col-lg-2 col-md-4 text-right">
        <label class="claim_label">First Name:</label>
      </div>
      <div class="col-lg-3 col-md-8 pl-lg-0">
        <input type="text" value="Mary" class="form-control">
      </div>
      <div class="col-lg-2 mt-2 mt-lg-0 col-md-4 text-right">
        <label class="claim_label">Last Name:</label>
      </div>
      <div class="col-lg-3 mt-2 mt-lg-0 col-md-8  pl-lg-0">
        <input type="text" value="Thompson" class="form-control">
      </div>
    </div>

    <div class="row mt-3 mb-3">
      <div class="col-lg-2 col-md-4 text-right">
        <label class="claim_label">Email Address:</label>
      </div>
      <div class="col-lg-4 col-md-8 pl-lg-0">
        <input type="text" value="mthompson@insurance.com" class="form-control">
      </div>
    </div>

    <div class="row mt-3 mb-3">
      <div class="col-lg-2 col-md-4 text-right">
        <label class="claim_label">Phone Number:</label>
      </div>
      <div class="col-lg-3 col-md-8 pl-lg-0">
        <input type="text" value="1-888-555-1234" class="form-control">
      </div>
    </div>

    <div class="row mt-3 mb-0">
      <div class="col-lg-2 col-md-4 text-right">
        <label class="claim_label">Additional <br>Information:</label>
      </div>
      <div class="col-lg-8 col-md-8 pl-lg-0">
        <textarea class="form-control" rows="5">  </textarea>
      </div>
    </div>

    <div class="row mt-4 ml-0 mr-0">
      <div class="col-md-12">
        <div class="claim_new_heading">Insured Information</div>
      </div>
    </div>

    <div class="row mt-0 mb-0">
      <div class="col-lg-2 col-md-4 text-right">
        <label class="claim_label">First Name:</label>
      </div>
      <div class="col-lg-3 col-md-8 pl-lg-0">
        <label class="claim_data_label">Walter</label>
      </div>
      <div class="col-lg-2 mt-2 mt-lg-0 col-md-4 text-right">
        <label class="claim_label">Last Name:</label>
      </div>
      <div class="col-lg-3 mt-2 mt-lg-0 col-md-8 pl-lg-0">
        <label class="claim_data_label">Smith</label>
      </div>
    </div>

    <div class="row mt-2 mb-3">
      <div class="col-lg-2 col-md-4 text-right">
        <label class="claim_label">Email Address:</label>
      </div>
      <div class="col-lg-4 col-md-8 pl-lg-0">
        <input type="text" value="waltersmith@insurance.com" class="form-control">
      </div>
    </div>

    <div class="row mt-3 mb-3">
      <div class="col-lg-2 col-md-4 text-right">
        <label class="claim_label">Phone Number:</label>
      </div>
      <div class="col-lg-3 col-md-8 pl-lg-0">
        <input type="text" value="1-888-555-1234" class="form-control">
      </div>
    </div>

    <div class="row mt-3 mb-0">
      <div class="col-lg-2 col-md-4 text-right">
        <label class="claim_label">Additional <br>Information:</label>
      </div>
      <div class="col-lg-8 col-md-8 pl-lg-0">
        <textarea class="form-control" rows="5">  </textarea>
      </div>
    </div>

    <div class="row mt-4 ml-0 mr-0">
      <div class="col-md-12">
        <div class="claim_new_heading">Documents <a href="#" class="add_new_hdng">Add New</a></div>
      </div>
    </div>

    <div class="row mt-3 mb-3">
      <div class="col-lg-2 col-md-4 text-right">
        <label class="claim_label">Document Type:</label>
      </div>
      <div class="col-lg-3 col-md-8 pl-lg-0">
        <!-- <select class="form-control classic">
          <option></option>
        </select> -->
        <p-dropdown></p-dropdown>
      </div>
    </div>

    <div class="row mt-3 mb-3">
      <div class="col-lg-2 col-md-4 text-right">
        <label class="claim_label">Upload Document:</label>
      </div>
      <div class="col-lg-3 col-md-4 pl-lg-0">
        <input type="text" class="form-control">
      </div>
      <div class="col-lg-2 col-md-4 mt-2 mt-lg-0 text-left">
        <!-- <a href="#" class="btn btn-sm mt-0 btn-primary cancel_btn font-600">Choose File</a> -->
        <button pButton type="button" class="btn btn-sm mt-0 btn-primary cancel_btn font-600"
          label="Choose File"></button>
      </div>
    </div>

    <div class="row mt-4 mb-4">
      <div class="col-lg-8 col-md-12 text-center">
        <!-- <a href="#" class="btn btn-primary mb-2 mb-lg-0 save_btn mr-2">Save Upload</a> -->
        <button pButton type="button" class="btn btn-primary mb-2 mb-lg-0 save_btn mr-2" label="Save Upload"></button>
        <button pButton type="button" class="btn btn-primary " label="Cancel Upload"></button>
        <!-- <a href="#" class="btn btn-primary">Cancel Upload</a> -->
      </div>
    </div>

    <div class="row mt-3 mb-3">
      <div class="col-md-12">
        <div class="col-lg-6 col-md-12 ">
          <table class="claims_table table-responsive" width="100%">
            <tr>
              <th>file Name</th>
              <th>Document Type</th>
              <th class="text-center">File Type</th>
            </tr>

            <tr>
              <td class="data_clr">police report 8/01/2020.pdf</td>
              <td>Police Report</td>
              <td class="text-center">
                <a href="#">
                  <i class="fa fa-file-pdf-o pdf_icn_clr" aria-hidden="true"></i>
                </a>
              </td>
            </tr>

            <tr>
              <td class="data_clr">West wing exterior.jpg</td>
              <td>Photo</td>
              <td class="text-center">
                <a href="#">
                  <i class="fa fa-picture-o pic_icn_clr" aria-hidden="true"></i>
                </a></td>
            </tr>

            <tr>
              <td class="data_clr border_none">West wing interior.jpg</td>
              <td class="border_none">Photo</td>
              <td class="text-center border_none"><a href="#">
                  <i class="fa fa-picture-o pic_icn_clr" aria-hidden="true"></i>
                </a></td>
            </tr>

          </table>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 ">
        <div class="col-md-12 border_top_1 pt-3 text-right">
          <!-- <a href="#" class="btn btn-primary mb-2 mb-lg-0  mr-2 save_btn font-600">Submit Claim</a>
          <a href="#" class="btn btn-primary mt-0 mr-0 cancel_btn font-600">Cancel New Claim</a> -->

          <button pButton type="button" class="btn btn-primary mb-2 mb-lg-0  mr-2 save_btn font-600"
            label="Submit Claim"></button>
          <button pButton type="button" class="btn btn-primary mt-0 mr-0 cancel_btn font-600 "
            label="Cancel New Claim"></button>
        </div>
      </div>
    </div>


  </div>
</div>